<template>
  <div class="content">

    <s-location use title="증표 사용"/>
    <!-- <template v-if="$store.state.session.user.type != 'master'"> -->
      <!--  주의사항  -->
      <div v-if="load_ok" class="comment expcomment mt20">

        <!-- 마스터 또는 김앤장이 아닌 소속변호사만 표시 -->
        <div v-if="$store.state.session.user.type == 'master' || ($store.state.session.user.type == 'member' && org_perm.likeself == '0')">
          <li><input type="checkbox" disabled :checked="org_perm.member_buy == '1'"/> 소속변호사가 증표를 구입할 수 있음</li>
          <li><input type="checkbox" disabled :checked="org_perm.master_buy_member_use == '1'"/> 법무법인 또는 공동법률사무소 아이디로 구입한 증표를 사용할 수 있음</li>
          <li class="star2">위 권한은 [마스터 아이디 로그인 - 마이페이지 - 소속변호사 권한 설정]에서 변경 가능합니다.</li>
        </div>

         <li class="star2"> 회원 본인이 구입한 증표 중 미사용 증표는 회원의 소속이 바뀔 경우
        <span id="id_msg"><em  class="blue01">변경된 소속으로 자동전환</em>
          <div class="toggleInfo">
            <p class="tit_info">예시</p>
            <div class="cont" style="font-size: 14px;">
              <p style="color: red;">※ 회원 본인이 구입한 증표 중 미사용 증표는 회원의 소속이 바뀔 경우 변경된 소속으로 자동전환됩니다.</p>
              <ol>
                <li>개인 > 법무법인, 공동법률사무소 소속변호사로  이전할 경우<br/>
                  홍길동 > 홍길동(법무법인 A) </li>
                <li>법무법인, 공동법률사무소 > 개인으로 이전할 경우<br/>
                  홍길동(법무법인 A) > 홍길동 </li>
                <li>법무법인, 공동법률사무소 > 법무법인, 공동법률사무소 이전할 경우<br/>
                  홍길동(법무법인 A) > 홍길동(법무법인 B) </li>
              </ol>
                <p> &nbsp; &nbsp; &nbsp; (회원 소속정보 변경 내역은 다음날 반영됩니다)</p>
            </div>
          </div>

        </span>됩니다.
          </li>
      </div>
    <!-- </template> -->


    <div class="btn_group mt0">
      <div class="right">
        <button @click="initData" class="btn icon reload">초기화</button>
        <button @click.prevent="doSearch(null,null,1)" class="btn icon search_black">검색</button>
        <button @click.prevent="$refs.excel.down()" class="btn icon excel">엑셀 다운</button>
      </div>
    </div>
    <table class="tbl01 sch_tbl">
      <tr>
        <th>증표 종류</th>
        <td class="radio_inline">
          <c증표종류_검색폼 :search.sync="search" />
        </td>
      </tr>
      <tr>
        <th>증표 번호</th>
        <td>
          <input type="text" v-model="search.iv_rcptno1" class="w_inputno" @keyup.enter="doSearch(null,null,1)" v-mask="'#####'" v-on:keyup="$event.target.value.length >= 5 && $event.target.nextElementSibling.focus()"/> -
          <input type="text" v-model="search.iv_rcptno2" class="w_inputno" @keyup.enter="doSearch(null,null,1)" v-mask="'######'"/>
        </td>
      </tr>
      <tr>
        <th>구입 일자</th>
        <td>
          <i-input-date input-class="w_inputno" title="시작일" v-model="search.iv_selldtfr" :placeholder="search.iv_selldtfr"/>
        ~ <i-input-date input-class="w_inputno" title="종료일" v-model="search.iv_selldtto" :placeholder="search.iv_selldtto"/>
         <span class="radio_date">
            <s-date-range :fr.sync="search.iv_selldtfr" :to.sync="search.iv_selldtto" />
         </span>
        </td>
      </tr>
      <tr>
        <th>검색어</th>
        <td>
          <!--
          <select v-model="search.iv_ktype">
            <option value="ALL"      >전체</option>
            <option value="MEMBNM"   >증표명의</option>
            <option value="CLIENT"   >위임인</option>
            <option value="OTHERSIDE">상대방</option>
            <option value="REMK"     >비고</option>
          </select> -->
          <!-- 검색 항목 : 증표명의, 위임인, 상대방, 관할기관, 사건명, 사건번호, 비고  -->
          <input type="text" class="sch_input" title="(조회 가능 항목 : 증표명의, 증표종류, 관할기관, 사건명, 사건번호, 위임인, 상대방, 비고)" v-model="search.iv_kword" placeholder="(조회 가능 항목 : 증표명의, 증표종류, 관할기관, 사건명, 사건번호, 위임인, 상대방, 비고)" @keyup.enter="doSearch(null,null,1)" />
        </td>
      </tr>
      <tr>
        <th>증표 구분</th>
        <td>
          <!-- <label><input type="radio" v-model="search.iv_onlineyn" value=""  />전체</label> -->
          <label><input type="radio" v-model="search.iv_onlineyn" value="Y" /><img src="/images/common/icon_online2.png"  class="icon_online" title="전자증표"> 전자증표</label>
          <label><input type="radio" v-model="search.iv_onlineyn" value="N" />종이증표</label> <label style="color: red;">※ 종이 증표 검색 사용시 위 증표번호에 해당 증표 번호 입력 후 검색을 눌러 주세요</label>
<!--           <select v-model="search.iv_onlineyn" style="width:80px">
            <option value="">전체</option>
            <option value="Y">온라인</option>
            <option value="N">오프라인</option>
          </select> -->
        </td>
      </tr>
    </table>
    <!-- 탭메뉴 시작 -->

    <div class="sub_tabmenu type03 ">
      <ul class="d07">
        <li :class="{ 'on' : search.iv_statclsf == 'BC0100#BC0500' }" @click="doSearch($event, 'BC0100#BC0500', 1)">전체</li>
        <li :class="{ 'on' : search.iv_statclsf == 'BC0100'        }" @click="doSearch($event, 'BC0100'       , 1)">미사용</li>
        <li :class="{ 'on' : search.iv_statclsf == 'BC0500'        }" @click="doSearch($event, 'BC0500'       , 1)">임시저장</li>

        <!-- <li :class="{ 'on' : search.iv_statclsf == 'BC0200'               }" @click="doSearch($event, 'BC0200'              , 1)">사용</li> -->
      </ul>
    </div>
    <!-- 탭메뉴 끝 -->

    <!--목록 게시물 수 선택 -->

    <select class="s_listcnt"
      :value="list.listSize"
      @input="e=>{
          list.listSize = Number(e.target.value) || 10
          doSearch(e, null, 1);
        }">
      <option value="">게시물 수</option>
      <option value="10">10건</option>
      <option value="20">20건</option>
      <option value="30">30건</option>
      <option value="50">50건</option>
    </select>
    <i-input-sel class="s_listcnt"
      :value="list.listSize"
      @input="v=>{
        list.listSize = Number(v) || 10
        doSearch(null, null, 1)
      }"
      itemsp="/게시물 수 | 10 / 10건 | 20 / 20건 | 30 / 30건 | 50 / 50건" />

    <s-excel
      ref="excel"
      excel-api="/proc_excel/N_VIAINFO_SEL_LIST_EMP"
      excel-filename = "증표"
      :isDebug="false"
      :excel-top ="`

          조회기간 : ${ search.iv_selldtfr } ~ ${ search.iv_selldtto }

       `"
      excel-headers = "
          text      | value           | format
          증표명의  | ownernm
          사용여부  | statclsfnm
          구입일자  | selldt          | YYYY.MM.DD.
          증표종류  | org_caseclsfnm
          증표번호  | rcptno          | insertHyphen(5)
          비고      | remk            |
      "
      :excel-param = "()=>({
        ...search,
        iv_pgsize       : '-1',
        iv_page         : '1',
    })"/>
    <!-- 테이블 -->
    <s-loading v-if="list.loading" />
      <div class="scroll_wrap">
        <p class="scroll_txt"> &lt;-&gt; 좌우 스크롤을 이용하세요</p>

        <table class="tbl01">
          <thead>
            <tr>
              <th class="no" >순번</th>
              <th class="vianame">증표명의</th>
              <th class="viakind">사용여부</th>
              <th class="date">구입일자</th>
              <th width="80px">증표종류</th>
              <th width="80px">증표<br v-if="search.iv_statclsf == 'BC0500'"/>번호</th>
              <template v-if="search.iv_statclsf == 'BC0500'"><!-- [임시저장] 탭에서만 -->
                <th class="vianame">사건명</th>
                <th class="viakind">위임인<br/>구분</th>
                <th class="vianame">위임인</th>
              </template>
              <!-- <th>온라인여부</th> -->
              <th>비고</th>
              <th class="btn01">사용</th>
            </tr>
          </thead>
          <tr v-for="(item,i) in list.items" :key=i>
            <td>{{ list.totalCount - ((list.pageNo -1) * list.listSize) - i }}</td>
            <td v-html="T.nl_to_br(item.ownernm)"></td>
            <td>{{ item.statclsfnm  }}</td>
            <td>{{ item.selldt | moment('YYYY.MM.DD.') }}</td>
            <!-- <td>{{ item.caseclsfnm  }}</td> -->
            <td>{{ item.org_caseclsfnm  }}</td>
            <td>{{ item.rcptno | insertHyphen(5) }}<img v-if="item.onlineyn == 'Y'" src="/images/common/icon_online2.png" alt="온라인증표" class="icon_online"></td>
            <template v-if="search.iv_statclsf == 'BC0500'">
              <td>{{ item.casenm }}</td>
              <td>{{ item.clientclsf }}</td>
              <td>{{ item.client }}</td>
            </template>
            <!-- <td>{{ item.onlineyn }}</td> -->
            <td class="input_btn">
              <input type="text"
                     title="비고 입력"
                     v-model="item.remk"
                     placeholder="비고 입력"
                     />
              <button @click="itemUpdate(item)" class="btn xs black02">비고저장</button>
            </td>
            <td>
              <button class="btn xs org01" @click="callDialogViaUse(item)">사용</button>
              <!--  <a href="buy_receipt" class="btn xs blue02 outline">전환</a> -->
            </td>
          </tr>
        </table>
      </div> <!-- //scroll_wrap -->

    <div class="paging">
      <p class="num">
        <s-page :pageNo.sync="list.pageNo" :totalCount="list.totalCount" :listSize="list.listSize" @changePage="doSearch"/>
      </p>
    </div>

    <!-- //변경내용 -->
    <!-- href="buy_ok" -->

    <div class="btn_group ">
      <button class="btn s black01 right" @click="uploadMode = !uploadMode">일괄사용</button>
    </div>

    <div v-if="uploadMode">
      <table class="tbl01">
        <tr>
          <th width="120">양식 다운로드</th>
          <td><i-btn><a href="/static/files/일괄사용_등록양식_V01.xlsx">일괄사용 엑셀양식 다운로드</a></i-btn></td>
        </tr>
        <tr>
          <th>첨부파일</th>
          <td class="pa-3">

            <i-fileupload name="file1" ref="file1" v-model="file1"
              action="/front/api/attach"
              :required=true
              kind="bulk_use"
              :exts="['xlsx']"
              @done="exceUploadDone">

              <template v-slot:uploadFile="{file, remove}">
                선택된 파일명 : <b>{{ file.name }}</b>
                ( 용량 : {{ file.size }} byte )
                <i-btn @click.prevent="remove(file)" :key="file.id">취소</i-btn>
              </template>
              <template v-slot:dropArea="{isDropActive}">
                <div class="drop-area" :class="{ 'can-drop': isDropActive }" v-if="!file1 || !file1.name">
                  여기에 끌어 놓으세요. 엑셀( xlsx ) 파일만 가능합니다.
                </div>
              </template>
              <i-bar-btn v-if="!file1 || !file1.name">업로드파일선택</i-bar-btn>
              &nbsp;
            </i-fileupload>
            <!-- file1 = {{ file1 }} -->
            <div v-if="file1 && file1.name">
              <i-bar-btn @click="doSubmit">등록</i-bar-btn>
              <br/> 등록 버튼을 클릭하시면 해당 증표의 정보가 저장되며 임시저장 상태로 변경됩니다.
              <br/> 사용을 원할 경우, 증표 상세 팝업 창의 인쇄 버튼을 클릭하여 사용해주시기 바랍니다.
            </div>
          </td>
        </tr>
      </table>
    </div>
	</div> <!-- content : width=950px; -->
</template>

<style scoped>
div.drop-area { width: 100%; height: 80px; padding-top: 30px; background-color: #EFEFEF; display: inline-block;}
div.drop-area.can-drop { font-weight: bold; color: red; }
</style>

<script>
let ui
import ModalViaFormVue from '../../components/ModalViaForm.vue';
export default {
  components: {
    'c증표종류_검색폼'   : require('@/components/c증표종류_검색폼.vue').default
  },
  data () {
    return {
      search : {},
      search_init : {
        iv_menu         : 'use'
      , iv_selldtfr     : ""//this.$moment().subtract(6, 'months').format("YYYY-MM-DD")
      , iv_selldtto     : ""//this.$moment().format("YYYY-MM-DD")
      // , iv_statclsf     : "BC0200#BC0100#BC0500"     // 사용,미사용, 임시저장건만 출력
      , iv_statclsf     : "BC0100#BC0500"     // 기본은 전체 탭
      , iv_viadtfr      : ""
      , iv_viadtto      : ""
      , iv_viaplac      : ""
      , iv_caseclsf     : ""
      , iv_rcptno1      : ""
      , iv_rcptno2      : ""
      , iv_rcptnofr     : ""
      , iv_rcptnoto     : ""
      , iv_cntchargdtfr : ""
      , iv_cntchargdtto : ""
      , iv_client       : ""
      , iv_isttoutplac  : ""
      , iv_otherside    : ""
      , iv_linkyn       : ""
      , iv_lostyn       : ""
      , iv_onlineyn     : "Y"
      , iv_lawyernm     : ""
      , iv_membclsf     : ""
      , iv_membno       : ""
      , iv_membnm       : ""
      , iv_viamembclsf  : ""
      , iv_viamembno    : ""
      , iv_officeclsf   : ""
      , iv_officeno     : ""
      , iv_order_by1    : ""
      , iv_order_by2    : ""
      , iv_order_by3    : ""
      , iv_order_by4    : ""
      , iv_freeclsf     : ""
      , iv_case_b10300  : ""
      , iv_ktype        : "ALL"
      , iv_kword        : ""
      , iv_cancelclsf   : ""
      , iv_searchdtgbn  : ""
      , iv_searchfr     : ""
      , iv_searchto     : ""
      },
      sitem : {
        reasonclsf : ''
      , reasonremk : ''
      },
      code: {},
      chkAll : false,
      list: {
        loading : false,
        items: [],
        totalCount: 0,
        listSize : 10,
        pageNo : 1,
      },
      excelHeaders : `
          vianame        | 증표명의
          viakind        | 사용여부
          day            | 구입일자
          viakind        | 증표종류
          viano          | 증표번호
      `,
      saveList : [],
      dayStr: ['일', '월', '화', '수', '목', '금', '토'],
      date: '2018-06-01',

      defaultPopperProps : {
        arrowPosition: 'start',
        arrowOffsetScaling: 1,
        popperOptions: {
          placement: 'bottom-start',
          positionFixed: true,
          // more options in https://popper.js.org
        },
      },

      uploadMode: false,
      file1: null,
      org_perm: {},
      load_ok: false,
      winHeight: 0,
    }
  },
  watch : {
    '$route': 'initData',
  },
  created() {
    ui = this.$ui;
    this.search = { ...this.search_init }
    if (this.$store.state.session.user.type != 'self') {  // 개인변호사가 아니면 다 있다
      ui.httpGet("/proc/N_OFFICE_MEM_SEL_DTL", {}, ret => this.org_perm = ret.data.rs1[0], null, v=>this.load_ok = true)
    } else {
      this.load_ok = true
    }
    // console.log("ModalViaFormVue = ", ModalViaFormVue);
    // console.log("window.innerHeight = ", window.innerHeight);

    // ModalViaFormVue.test()
  },
  mounted() {
    this.doSearch(null,null,1)

    this.$nextTick(() => {
      this.onResize()
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods : {
    onResize() {
      this.winHeight = window.innerHeight
    },
    initData(){ // 현재 메뉴 다시 클릭 시
      this.search = T.deepCopy(this.search_init)
      this.doSearch(null,null,1)
    },
    /* saveItem(item) {
      ui.confirm('저장하시겠습니까 ?', "저장 확인")
        .then(r => r && this.itemUpdate(item))
    }, */
    itemUpdate(item) {

      ui.httpPost("/proc_iv/N_VIAINFO_UPD_REMK_DTL_EMP",
      item,
      ret => {
        const {msg, status } = ret.data.rs1[0];
        ui.notify(msg);

         if (status == '0') { // 작업이 정상 완료일때 완료페이지로 이동
          //this.$router.push({ path: 'buy_ok', query: { sellregdt, sellseq }})
          //ui.notify(msg);
           this.doSearch()
        }

      })
    },
    callDialogViaUse(item) {
      // 소속변호사일때 권한체크
      if (this.$store.state.session.user.type == 'member') {
        ui.httpGet('/proc/N_FRONT_AUTH_CHECK',
        {
          iv_flag     : 'V',
          iv_viaregdt : item.viaregdt,
          iv_viaseq   : item.viaseq,
        },
        ret => {
          // 증표권한 반환
          let buyAuthYn = ret.data.rs1[0].auth_yn

          if (buyAuthYn == '0') {
            return ui.alert("증표 사용 권한이 없습니다.");
          } else {
            item.ch_statclsf = 'BC0200'
            item.modal_title = '증표 사용 등록'

            this.callVieModal(item)
          }
        })
      } else {
        item.modal_title = '증표 사용 등록'
        this.callVieModal(item)
      }
    },
    callVieModal(item) {
      // this.$refs.dialog_usevia.open(item) // 원래소스

    // :name="modalName"
    // adaptive reset
    // draggable=".window-header"
    // @closed="closed"
    // overlayTransition=""
    // width="900"
    // height="auto" scrollable
    // :clickToClose=false

      this.$modal.show(ModalViaFormVue, {
        // 프로퍼티
        menu: 'front_use',
        param: item,
          // 없음
        // 콜백
        cb_save: this.doSearch,
        cb_via_use_ok: this.via_use_ok,
      }, {
        // 모달 속성
//        class: 'v--modal-overlay test-modal',
        name: "viaForm_" + T.randomAZ(10), // 모달 이름 (unique)
        adaptive: true,
        // reset: true,
        // draggable: ".window-header",
        // overlayTransition: "",
        width: "900",
        height: (Math.min(1000, this.windowHeight -25) ),
        // height: this.windowHeight - 25,
        // height: 'auto',
        // scrollable: true, // height: auto 하고 scrollable:true 는 한세트
      // scrollable: true를 하게되면 IE9 에서 작동하지 않는다. 절대 주지 말자.
      // 또는 $device.fullBrowserVersion == 9 && $device.isIE == true 일때 false 로 하고 그 외에는 true로 하자

        clickToClose: false,

        // resizable: true,
        // pivotY: 0.3,
      }, {
        // 이벤트
        // 'before-close': (e,v) => { console.log('모달을 닫는다1. event =', e); console.log('모달을 닫는다2. event =', v);  },
        // 'closed': (e,v) => { console.log('모달3 CLOSED =', e); console.log('모달4 CLOSED =', v); },

        //@closed="closed"
      })


    },
    doSearch(e, iv_statclsf, pageNo) {
     if (this.search.iv_onlineyn =="N" && this.search.iv_rcptno1 == "" && this.search.iv_rcptno2 == "" ) {

        ui.alert("종이 증표 검색 및 사용을 원하실 경우 종이 증표 번호를 위 증표 번호 검색란에 입력 후 검색 해주세요.\n")

      } else if (this.search.iv_onlineyn =="N" && this.search.iv_rcptno1 == "") {

       ui.alert("증표번호 앞자리를 입력해주세요.\n")

      } else if (this.search.iv_onlineyn =="N" && this.search.iv_rcptno2 == "") {

       ui.alert("증표번호 뒷자리를 입력해주세요.\n")

      }
      else
      {
      this.search.iv_rcptnofr = this.search.iv_rcptno1 + "" + this.search.iv_rcptno2
      this.search.iv_rcptnoto = this.search.iv_rcptnofr

      this.search.iv_statclsf = iv_statclsf || this.search.iv_statclsf
      this.list.pageNo = pageNo || this.list.pageNo

      ui.httpGetList(this.list
        , '/proc/N_VIAINFO_SEL_LIST_EMP'
        , {
          ...this.search
          , iv_pgsize      : this.list.listSize
          , iv_page        : this.list.pageNo
        },
        ret => {
          this.list.totalCount = _.get(ret, "data.rs1[0].tot_rows", 0)
          this.list.items      = _.get(ret, "data.rs2", [])
        })

      }
    },
    doSubmit() {
      this.$refs.file1.start(this.uploadItem)
    },
    exceUploadDone() { // 엑셀업로드 완료
      //this.$refs.file1.clear();
      console.log("등록시작");
      console.log("file1 = ", this.file1.path);

      ui.httpGet("/bulk_use_excel_upload",
        {path: this.file1.path},
        ret=> {
          this.$refs.file1.clear()

          if (_.get(ret, "data.status") == "ok") {
            // this.file1 = {}
            //this.$refs.file1.clear()
            this.doSearch()
            // console.log("ret.data", ret.data);
            ui.alert("등록이 완료되었습니다.\n" + ret.data.msg)

          } else {
            ui.alert_error("등록 중 에러가 발생하였습니다.\n\n" + ret.data.msg)
          }
        }

      )
    },
    via_use_ok(viaInfo) { // 증표사용 증표상세모달에서 증표를 사용한 경우
      console.log("증표사용함 :", viaInfo);
      this.$router.push({ path: '/use/edit_via', query: {
        iv_searchfr: this.$moment().format("YYYY-MM-DD"),
        iv_searchto: this.$moment().format("YYYY-MM-DD"),
      }})
    },
  }
}
</script>
<style scoped>
  .s_listcnt { position : absolute; float : right;  margin-top:-40px; right:0;}


  #id_msg:hover .toggleInfo {  margin-top:30px; margin-left:-440px; display: inline-block; }
  .toggleInfo .tit_info {  color:#fff; display: inline-block; padding: 10px 15px 10px 40px; ;width:100%; box-sizing: border-box; font-size: 15px;;background:#333 url('/images/common/icon_info_org.png')  15px 50% no-repeat; }

  @media screen and (max-width:640px){
    .tbl01.sch_tbl td label { min-width: 30px; display: inline-block;}


    /* .tbl01 { width:100%;} */
    .sub_tabmenu { margin-top:50px;}
    .s_listcnt { margin:-37px 15px 0 0}

    .scroll_wrap { padding-top:0}
    .scroll_wrap .scroll_txt { margin-top:-60px; }

    #id_msg:hover .toggleInfo {  margin-top:30px; margin-left:-165px; display: inline-block; }

  }

</style>